import { createFontStyle } from '../'

const Label = createFontStyle('Label', { type: 'Label', tagName: 'span', name: '1' }, ({ inverseColor, inactive, theme }) => {
  const { label } = theme.custom

  if (inactive) {
    return { color: label.disabled.color }
  }
  return {
    color: inverseColor ? label.inverse.color : label.default.color,
    direction: 'ltr'
  }
})

export default Label
